import React, { useMemo, useState } from "react";
import analyticsStyles from "../../styles/Analytics.module.css";
import panelStyles from "../../styles/Panel.module.css";
import { EMPTY_REQUESTS_PERIOD } from "../../constants";

const PERIOD_OPTIONS = [
  { value: "day", label: "Сегодня" },
  { value: "week", label: "Неделя" },
  { value: "month", label: "Месяц" },
  { value: "allTime", label: "Всё время" }
];

function formatPct(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0%";
  return `${Math.round(n * 10) / 10}%`;
}

function formatTrend(value) {
  if (value === null || value === undefined) return "—";
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return "→ 0%";
  const abs = Math.round(Math.abs(n) * 10) / 10;
  return n > 0 ? `↑ +${abs}%` : `↓ -${abs}%`;
}

export function AnalyticsRequestsBlock({ requests }) {
  const [period, setPeriod] = useState("week");

  const current = useMemo(() => {
    const fallback = { ...EMPTY_REQUESTS_PERIOD };
    return {
      ...(fallback || {}),
      ...((requests && requests[period]) || {})
    };
  }, [period, requests]);

  const rows = Array.isArray(current.rows) ? current.rows : [];
  const totalRequests = Number(current.totalRequests || 0);
  const topRow = rows[0] || null;
  const monetizedCount = rows.filter((row) => Boolean(row.monetized)).length;

  return (
    <div className={analyticsStyles.block}>
      <div className={analyticsStyles.chartHeader}>
        <div>
          <h3>Ниши запросов</h3>
          <div className={panelStyles.note}>Статистика по категориям запросов без привязки к native-рекламе.</div>
        </div>
        <select className={panelStyles.select} value={period} onChange={(e) => setPeriod(e.target.value)}>
          {PERIOD_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className={analyticsStyles.kpis}>
        <div className={panelStyles.panel}>
          <div className={panelStyles.note}>Запросов</div>
          <div className={panelStyles.title}>{totalRequests.toLocaleString("ru-RU")}</div>
        </div>
        <div className={panelStyles.panel}>
          <div className={panelStyles.note}>Ниш в выдаче</div>
          <div className={panelStyles.title}>{rows.length}</div>
        </div>
        <div className={panelStyles.panel}>
          <div className={panelStyles.note}>Монетизированных ниш</div>
          <div className={panelStyles.title}>{monetizedCount}</div>
        </div>
        <div className={panelStyles.panel}>
          <div className={panelStyles.note}>Лидер</div>
          <div className={panelStyles.title}>{topRow ? topRow.label : "—"}</div>
        </div>
      </div>

      <div className={panelStyles.tableWrap}>
        <table className={panelStyles.table}>
          <thead>
            <tr>
              <th>Категория</th>
              <th>Запросов</th>
              <th>% от всех</th>
              <th>Тренд</th>
              <th>Монетизирован?</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((row) => (
                <tr key={row.nicheId || row.label}>
                  <td>
                    <div style={{ fontWeight: 700 }}>{row.label}</div>
                    <div className={panelStyles.note}>{row.nicheId}</div>
                  </td>
                  <td>{Number(row.requests || 0).toLocaleString("ru-RU")}</td>
                  <td>{formatPct(row.sharePct ?? row.shareOfTotal ?? 0)}</td>
                  <td>{formatTrend(row.trendPct)}</td>
                  <td>
                    {row.monetized ? (
                      <span className={panelStyles.chip}>{row.monetizationLabel || "Да"}</span>
                    ) : (
                      <span className={panelStyles.note}>Нет</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className={panelStyles.note}>Пока нет данных по нишам. Как только пользователи начнут писать запросы, таблица заполнится.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div>
        <h3>Авто-инсайты</h3>
        {Array.isArray(current.insights) && current.insights.length ? (
          <ul className={analyticsStyles.list}>
            {current.insights.map((item, index) => (
              <li key={`request-insight-${index}`}>{item}</li>
            ))}
          </ul>
        ) : (
          <div className={panelStyles.note}>Пока недостаточно данных для автоматических инсайтов.</div>
        )}
      </div>
    </div>
  );
}

export default AnalyticsRequestsBlock;
